import { Component, OnDestroy } from '@angular/core';
import { ReleaseStatsModel } from '../../../models/release-stats.model';
import { Subscription } from 'rxjs';
import { WireReportService } from '../wire-report.service';
import { SortOrderEnum } from '../../../../../api/shared/enums/sort-order.enum';
import { messageSeverityEnum } from '../../../../../Common/Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '../../../../../Common/Forms/enums/button-types.enum';

enum PostingSortTypeEnum {
    date,
    alexaTraffic,
    mozDA,
    postingTraffic
}

@Component({
    selector: 'agpr-wire-performance-report',
    templateUrl: './wire-performance-report.component.html',
    styleUrls: ['./wire-performance-report.component.scss'],
    standalone: false
})
export class WirePerformanceReportComponent implements OnDestroy {

    performanceReport: ReleaseStatsModel;
    reportLoading: boolean = false;
    dateSortOrder: SortOrderEnum = SortOrderEnum.ascending;
    alexaTrafficSortOrder: SortOrderEnum = SortOrderEnum.descending;
    mozDASortOrder: SortOrderEnum = SortOrderEnum.descending;
    postingTrafficSortOrder: SortOrderEnum = SortOrderEnum.descending;


    subscriptions: Subscription[] = [];
    readonly postingSortType = PostingSortTypeEnum;
    readonly sortOrder = SortOrderEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;

    constructor(
        public wireReportService: WireReportService
    ) {
        this.subscriptions.push(
            this.wireReportService.getPerformanceReport().subscribe(performanceReport => {
                if (performanceReport) {
                    if (Object.keys(performanceReport).length){
                        this.performanceReport = performanceReport;
                        this.toggleSortPostingStats(PostingSortTypeEnum.date);
                    }
                } else {
                    this.performanceReport = null;
                }
            }),
            this.wireReportService.getPerformanceReportLoading().subscribe(loading => this.reportLoading = loading)
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    toggleSortPostingStats(field: PostingSortTypeEnum) {
        switch (field) {
            case PostingSortTypeEnum.date:
                if (this.dateSortOrder === SortOrderEnum.ascending) {
                    this.dateSortOrder = SortOrderEnum.descending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => b.nqFirstSeen - a.nqFirstSeen);
                } else {
                    this.dateSortOrder = SortOrderEnum.ascending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => a.nqFirstSeen - b.nqFirstSeen);
                }
                break;
            case PostingSortTypeEnum.alexaTraffic:
                if (this.alexaTrafficSortOrder === SortOrderEnum.ascending) {
                    this.alexaTrafficSortOrder = SortOrderEnum.descending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => b.alexaGlobalRank - a.alexaGlobalRank);
                } else {
                    this.alexaTrafficSortOrder = SortOrderEnum.ascending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => a.alexaGlobalRank - b.alexaGlobalRank);
                }
                break;
            case PostingSortTypeEnum.mozDA:
                if (this.mozDASortOrder === SortOrderEnum.ascending) {
                    this.mozDASortOrder = SortOrderEnum.descending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => b.mozDaScore - a.mozDaScore);
                } else {
                    this.mozDASortOrder = SortOrderEnum.ascending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => a.mozDaScore - b.mozDaScore);
                }
                break;
            case PostingSortTypeEnum.postingTraffic:
                if (this.postingTrafficSortOrder === SortOrderEnum.ascending) {
                    this.postingTrafficSortOrder = SortOrderEnum.descending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => b.totalTraffic - a.totalTraffic);
                } else {
                    this.postingTrafficSortOrder = SortOrderEnum.ascending;
                    this.performanceReport.postingStats = this.performanceReport.postingStats.sort((a, b) => a.totalTraffic - b.totalTraffic);
                }
                break;
        }
    }
}
